import { render, staticRenderFns } from "./ImpersonationForm.vue?vue&type=template&id=07c81dc8"
import script from "./ImpersonationForm.vue?vue&type=script&lang=js"
export * from "./ImpersonationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports